import React from 'react'
import PaymentHistory from "./PaymentHistory";
import { Divider } from "@mui/material";

const ClientConsultationHistory = () => {
  return (
    <div>
      <PaymentHistory />
    </div>
  );
};

export default ClientConsultationHistory